// extracted by mini-css-extract-plugin
export var checkboxContainer = "Checkbox-module--checkboxContainer--UGzdF";
export var hiddenCheckbox = "Checkbox-module--hiddenCheckbox--F6YNs";
export var hide = "Checkbox-module--hide--LdKjI";
export var icon = "Checkbox-module--icon--yIqoi";
export var show = "Checkbox-module--show--heovG";
export var styledCheckbox = "Checkbox-module--styledCheckbox--VHwqI";